module.exports = __webpack_public_path__ + "media/homepage/smiling-female-d04f052e.webp";